import { Grid, Box, Divider, Button, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { addToCart, dashboardAddToCart } from '../../functions/orders';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';

const CartCard = ({
  setIsDeleting,
  setDeleteAction,
  deleteAction,
  cartItem,
  id,
  food_image_json,
  food_name,
  food__price,
  ordered_addons,
  quantity,
  food_code
}) => {
  const {
    branch: { currentBranch: { restaurant_code } },
    auth: { user: { id: user_id } }
  } = useSelector((state) => state);

  const [qLoading, setQLoading] = useState({ id: "", action: false });
  const { state } = useLocation() || {};

  const buildAddToCartPayloadFromCartItem = () => {
    const food = cartItem.food;

    const variant = (() => {
      if (!food?.variants?.length) return [];

      return food.variants
        .map(v => {
          const match = v.values.find(
            val => Number(val.price) === cartItem.total_price
          );
          return match
            ? {
                name: v.name,
                value: match.value_name,
                price: Number(match.price),
              }
            : null;
        })
        .filter(Boolean);
    })();

    return {
      restaurant_code,
      food_code,
      quantity,
      additional_notes: cartItem.additional_notes || "",
      add_ons: ordered_addons,
      amount: food__price,
      variant,
      ...(cartItem.order_id ? { order_id: cartItem.order_id } : {}),
    };
  };

  const handleQuantity = async (isIncrement) => {
    setQLoading({ id: cartItem.id, action: true });

    try {
      if (isIncrement) {
        const payload = buildAddToCartPayloadFromCartItem();

        const onSuccess = (res) => {
          toast.success(res.data.message);
          setQLoading(null);
          window.history.back();
        };

        const onError = (err) => {
          toast.error(err?.response?.data?.message || "Failed to add item");
          setQLoading(null);
        };

        state
          ? addToCart(payload).then(onSuccess).catch(onError)
          : dashboardAddToCart(payload, user_id).then(onSuccess).catch(onError);

      } else {
        setIsDeleting(true);
        setDeleteAction({ ...deleteAction, item: food_name, id });
        setQLoading(null);
      }
    } catch (err) {
      toast.error("Cart update failed");
      setQLoading(null);
    }
  };

  return (
    <div className='flex justify-between items-start bg-white shadow p-3 rounded flex-col md:flex-row'>
      <div className='flex flex-row space-x-4 w-full'>
        <img
          src={food_image_json[0]?.url}
          alt={food_name}
          className='h-10 w-10 rounded-full'
        />
        <div className='space-y-1'>
          <h2 className='text-[15px] font-semibold'>
            {food_name?.charAt(0)?.toUpperCase() + food_name?.slice(1)?.toLowerCase()}
          </h2>
          <p className='text-xs font-bold text-primary'>
            {food__price?.toLocaleString("en", { style: "currency", currency: "KSH" })}
          </p>

          {Array.isArray(ordered_addons) &&
            ordered_addons.map(({ addons_extras: { price, food_name, food_image_json } }) => (
              <div key={food_name} className="flex items-center gap-2">
                <img
                  src={food_image_json[0]?.url}
                  className="h-8 w-8 rounded border p-1"
                />
                <div>
                  <p className="text-sm capitalize">{food_name}</p>
                  <p className="text-xs font-semibold text-primary">
                    {price.toLocaleString("en", { style: "currency", currency: "KSH" })}
                  </p>
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className='flex items-center space-x-10 mt-2 md:mt-0'>
        <div className='flex items-center space-x-4'>
          <div
            onClick={() => handleQuantity(false)}
            className='h-7 w-7 shadow bg-white rounded-full flex items-center justify-center cursor-pointer'
          >
            {(qLoading?.id === cartItem.id && !qLoading?.action)
              ? <CircularProgress size={18} />
              : <RemoveIcon sx={{ fontSize: 16 }} />}
          </div>

          <h2 className='font-bold'>{quantity?.toString().padStart(2, "0")}</h2>

          <div
            onClick={() => handleQuantity(true)}
            className='h-7 w-7 shadow bg-white rounded-full flex items-center justify-center cursor-pointer'
          >
            {(qLoading?.id === cartItem.id && qLoading?.action)
              ? <CircularProgress size={18} />
              : <AddIcon sx={{ fontSize: 16 }} />}
          </div>
        </div>

        <DeleteIcon
          className="cursor-pointer"
          onClick={() => {
            setDeleteAction({ ...deleteAction, item: food_name, id });
            setIsDeleting(true);
          }}
        />
      </div>
    </div>
  );
};

export default CartCard;
